import React, { memo } from 'react';
import * as styles from './Categories.module.scss';
const pickFallback = source => {
  if (!source) {
    return null;
  }
  return source.fallback || source.src || source.webp || source.avif || null;
};
const getMimeType = src => {
  var _src$split$0$split$po;
  if (!src) {
    return undefined;
  }
  const extension = (_src$split$0$split$po = src.split('?')[0].split('.').pop()) === null || _src$split$0$split$po === void 0 ? void 0 : _src$split$0$split$po.toLowerCase();
  switch (extension) {
    case 'png':
      return 'image/png';
    case 'jpg':
    case 'jpeg':
      return 'image/jpeg';
    case 'webp':
      return 'image/webp';
    case 'avif':
      return 'image/avif';
    case 'gif':
      return 'image/gif';
    default:
      return undefined;
  }
};
const DESKTOP_MEDIA = '(min-width: 811px)';
const MOBILE_MEDIA = '(max-width: 809px)';
const appendSources = (list, source, media, keyPrefix) => {
  if (!source) {
    return;
  }
  if (source.avif) {
    list.push(/*#__PURE__*/React.createElement("source", {
      key: `${keyPrefix}-avif`,
      media: media,
      srcSet: source.avif,
      type: "image/avif"
    }));
  }
  if (source.webp) {
    list.push(/*#__PURE__*/React.createElement("source", {
      key: `${keyPrefix}-webp`,
      media: media,
      srcSet: source.webp,
      type: "image/webp"
    }));
  }
  const fallback = pickFallback(source);
  if (fallback) {
    list.push(/*#__PURE__*/React.createElement("source", {
      key: `${keyPrefix}-fallback`,
      media: media,
      srcSet: fallback,
      type: getMimeType(fallback)
    }));
  }
};
const CategoryCard = /*#__PURE__*/memo(function CategoryCard({
  item,
  priority = false
}) {
  var _picture$dimensions, _picture$dimensions2;
  if (!item) {
    return null;
  }
  const {
    heading,
    link,
    picture
  } = item;
  const alt = (picture === null || picture === void 0 ? void 0 : picture.alt) || '';
  const fallbackSrc = pickFallback(picture === null || picture === void 0 ? void 0 : picture.desktop) || pickFallback(picture === null || picture === void 0 ? void 0 : picture.mobile);
  const hasImage = Boolean(fallbackSrc);
  const width = picture === null || picture === void 0 ? void 0 : (_picture$dimensions = picture.dimensions) === null || _picture$dimensions === void 0 ? void 0 : _picture$dimensions.width;
  const height = picture === null || picture === void 0 ? void 0 : (_picture$dimensions2 = picture.dimensions) === null || _picture$dimensions2 === void 0 ? void 0 : _picture$dimensions2.height;
  const fetchPriority = priority ? 'high' : undefined;
  const loading = priority ? 'eager' : 'lazy';
  const decoding = 'async';
  const sources = [];
  appendSources(sources, picture === null || picture === void 0 ? void 0 : picture.desktop, DESKTOP_MEDIA, 'desktop');
  appendSources(sources, picture === null || picture === void 0 ? void 0 : picture.mobile, MOBILE_MEDIA, 'mobile');
  return /*#__PURE__*/React.createElement("div", {
    className: styles.rootItem
  }, hasImage && /*#__PURE__*/React.createElement("picture", {
    className: styles.rootItemPicture
  }, sources, /*#__PURE__*/React.createElement("img", {
    className: styles.rootItemImage,
    src: fallbackSrc,
    alt: alt,
    loading: loading,
    decoding: decoding,
    fetchpriority: fetchPriority,
    width: Number.isFinite(width) ? width : undefined,
    height: Number.isFinite(height) ? height : undefined
  })), /*#__PURE__*/React.createElement("h3", {
    className: styles.rootItemHeading
  }, /*#__PURE__*/React.createElement("a", {
    className: styles.rootItemLink,
    href: link || '#',
    dangerouslySetInnerHTML: {
      __html: heading
    }
  })));
});
const Categories = ({
  heading = '',
  items = []
}) => {
  if (!(items !== null && items !== void 0 && items.length)) {
    return null;
  }
  const firstItem = items[0];
  const secondColumnItems = items.slice(1, 3);
  const thirdColumnItems = items.slice(3);
  const itemKey = (it, fallback) => {
    var _ref, _ref2, _it$id;
    return (_ref = (_ref2 = (_it$id = it === null || it === void 0 ? void 0 : it.id) !== null && _it$id !== void 0 ? _it$id : it === null || it === void 0 ? void 0 : it.link) !== null && _ref2 !== void 0 ? _ref2 : it === null || it === void 0 ? void 0 : it.heading) !== null && _ref !== void 0 ? _ref : fallback;
  };
  return /*#__PURE__*/React.createElement("section", {
    className: styles.root,
    "aria-label": heading ? heading.replace(/<[^>]*>/g, '') : 'Categories'
  }, /*#__PURE__*/React.createElement("div", {
    className: styles.rootContainer
  }, heading && /*#__PURE__*/React.createElement("h2", {
    className: styles.rootHeading,
    dangerouslySetInnerHTML: {
      __html: heading
    }
  }), /*#__PURE__*/React.createElement("div", {
    className: styles.rootGrid
  }, /*#__PURE__*/React.createElement("div", {
    className: styles.rootCol
  }, /*#__PURE__*/React.createElement(CategoryCard, {
    item: firstItem,
    priority: true
  })), /*#__PURE__*/React.createElement("div", {
    className: styles.rootCol
  }, secondColumnItems.map((item, idx) => /*#__PURE__*/React.createElement(CategoryCard, {
    key: itemKey(item, `col-2-${idx}`),
    item: item
  }))), /*#__PURE__*/React.createElement("div", {
    className: styles.rootCol
  }, thirdColumnItems.map((item, idx) => /*#__PURE__*/React.createElement(CategoryCard, {
    key: itemKey(item, `col-3-${idx}`),
    item: item
  }))))));
};
export default Categories;